module.exports = __webpack_public_path__ + "img/face-meh-blank.aa4fe5f1.svg";